<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LfFCZh/tc-custom/9781504090988.jpg?1731154339291" alt="This image is the cover for the book At the Crossroad, Black Horse Campground Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">At the Crossroad, Black Horse Campground Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>You can take the cop out of the big city, but you can’t take the big city out of the cop, in this fourth Black Horse Campground mystery.</b><br/>  <br/> Just as Corrie is getting used to having former Houston, Texas, narcotics detective J. D. Wilder as a campground employee, he officially becomes a member of the Village of Bonney Police Department. Aside from a recent crime spree at the Black Horse, not much is going on in town, giving Wilder a chance to go over some cold cases.<br/>  <br/> In the past fifteen years, three women have gone missing, exactly five years apart. What has amounted to nothing more than a local urban legend becomes Wilder’s new obsession—with Corrie offering some much-needed background information. As he’s digging into the neighborhood’s recent history, trouble from his own shows up, forcing the shadowy past into a deadly confrontation with a clear and present danger . . .<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy M Bennett
      </h2>
      
      <p class="authorDescription body article">Amy M.&#160;Bennett was born and raised in El Paso, Texas. <I>End of the Road</I> started as a project for National Novel Writing Month in 2009 but it went on to win Oak Tree Press&rsquo;s 2012 Dark Oak Mystery contest. Her first and second books in the series, <I>End of the Road</I> and <I>No Lifeguard on Duty</I>, were both awarded the Catholic Writers Guild Seal of Approval. She and her husband Paul currently reside in Bent, New Mexico, with their son, Paul Michael.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39ea1fd6